// The markdown subset assistant replies render with (site-assistant SA22), and the
// plain-text form a reply copies as. Model output is untrusted - read tools feed
// it community content other people wrote - so the renderer allows no HTML, no
// images, and links only to paths on this site.

/** Elements react-markdown may emit; everything else is unwrapped to its text (images have none, so vanish). */
export const ALLOWED_MARKDOWN_ELEMENTS = [
  "p",
  "br",
  "strong",
  "em",
  "ul",
  "ol",
  "li",
  "code",
  "a",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
];

const SAME_ORIGIN_BASE = "https://same-origin.invalid";

/**
 * Returns a normalized same-origin path, or "" for anything else. Resolving the
 * URL rather than pattern-matching it catches the browser's own rewrites -
 * `/\evil.com` and a tab inside `//` both resolve to another host.
 */
export function safeInternalHref(url: string): string {
  if (!url.startsWith("/")) return "";
  try {
    const resolved = new URL(url, SAME_ORIGIN_BASE);
    if (resolved.origin !== SAME_ORIGIN_BASE) return "";
    return `${resolved.pathname}${resolved.search}${resolved.hash}`;
  } catch {
    return "";
  }
}

/**
 * The text/plain half of Copy: markdown syntax removed so a paste into a plain
 * field reads cleanly, with list markers kept so a list still reads as one.
 */
export function markdownToPlainText(markdown: string): string {
  return markdown
    .replace(/\r\n/g, "\n")
    .replace(/!\[[^\]]*\]\([^)]*\)/g, "")
    .replace(/\[([^\]]+)\]\([^)]*\)/g, "$1")
    .replace(/^#{1,6}\s+/gm, "")
    .replace(/^(\s*)[*+]\s+/gm, "$1- ")
    .replace(/^>\s?/gm, "")
    .replace(/```[^\n]*\n?/g, "")
    .replace(/(\*\*|__)(.+?)\1/g, "$2")
    .replace(/(^|[^*\w])\*(?!\s)([^*\n]+?)\*(?!\w)/g, "$1$2")
    .replace(/(^|[^_\w])_(?!\s)([^_\n]+?)_(?!\w)/g, "$1$2")
    .replace(/`([^`\n]+)`/g, "$1")
    .replace(/<[^>\n]+>/g, "")
    .replace(/\n{3,}/g, "\n\n")
    .trim();
}
